import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import Loading from '../Loader';

export class LocationsList extends Component {
  static defaultProps = {
    isAdmin: false,
    onSelect: () => {},
  }
  static propTypes = {
    isAdmin: PropTypes.bool,
    onSelect: PropTypes.func,
  }
  render() {
    const { locations, isAdmin, onSelect } = this.props;
    let content;
    if (!locations || locations.fetching || !locations.list) {
      content = <TableRow><TableRowColumn><Loading /></TableRowColumn></TableRow>;
    }
    else {
      content = locations.list.map(item => {
        const { id, name, address, carrier, shipper } = item;
        return (<TableRow key={id}>
          <TableRowColumn>{name}</TableRowColumn>
          <TableRowColumn>{_.get(address, 'address')}</TableRowColumn>
          {isAdmin && <TableRowColumn>{_.get(shipper, 'name', 'unknown')}</TableRowColumn>}
          {isAdmin && <TableRowColumn>{_.get(carrier, 'name', 'unknown')}</TableRowColumn>}
        </TableRow>);
      });
    }

    return (
      <Table onRowSelection={onSelect}>
        <TableHeader>
          <TableRow>
            <TableHeaderColumn>Name</TableHeaderColumn>
            <TableHeaderColumn>Address</TableHeaderColumn>
            {isAdmin && <TableHeaderColumn>Shipper</TableHeaderColumn>}
            {isAdmin && <TableHeaderColumn>Carrier</TableHeaderColumn>}
          </TableRow>
        </TableHeader>
        <TableBody deselectOnClickaway={false}>
          { content }
        </TableBody>
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  const { locations } = state;
  return {
    locations
  }
}

export default connect(mapStateToProps)(LocationsList);


// WEBPACK FOOTER //
// ./src/components/Locations/List.js